import DefaultApiService from "./default";

const baseBySource = (source) =>
  source === "Management"
    ? "SLN/Management/InternalNotes"
    : "SLN/SolarentOperator/InternalNotes";

const RequestInternalNotesApi = {
  getByRequestId: async (source, requestInfoId) =>
    DefaultApiService.getCustomeApi(
      `${baseBySource(source)}/GetByRequestId/${requestInfoId}`
    ),

  create: async (source, data) =>
    DefaultApiService.postApi(`${baseBySource(source)}/Create`, data),

  delete: async (source, id) =>
    DefaultApiService.postApi(`${baseBySource(source)}/Delete?id=${id}`, {}),

  togglePin: async (source, id) =>
    DefaultApiService.postApi(`${baseBySource(source)}/TogglePin`, { id }),
};

export default RequestInternalNotesApi;
